<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="printAllLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAll')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllCreditBalance()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-select
                label="Date Type"
                :items="dateTypeList"
                v-model="queryParams.dateType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerNameCode"
                label="Customer Name/Code"
                type="text"
                v-model="queryParams.customerNameCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                item-text="label"
                item-value="value"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="saleTypeList"
                label="Sale Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.saleType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.saleTeamIds"
                :items="saleTeamList"
                label="Sale Team"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Credit Paid Amount:</span>
              <v-chip>
                <span>{{ totalCreditPaidAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Remaining Amount:</span>
              <v-chip>
                <span>{{ totalRemainingAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerCreditBalanceList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr :class="checkColor(props.item)">
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time}}</td>
              <td>{{ props.item.dueDateInMilliSeconds | format-ms-date-time}}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.saleTeamName }}</td>
              <td>{{ props.item.periodDay }}</td>
              <td style="text-align:right">{{ props.item.netAmount | decFormat(6)}}</td>
              <td style="text-align:right">{{ props.item.creditPaidAmount | decFormat(6)}}</td>
              <td style="text-align:right">{{ props.item.remainingAmount | decFormat(6)}}</td>
              <td>{{ props.item.saleType }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!--Print All-->
    <div id="printAll" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Customer Credit Balance</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate | formatDate}}] To: [{{queryParams.toDate | formatDate}}]</p>
      </div>
       <div style="text-align:center">
        <p style="font-size:15px;margin:1px">Reported Date: [{{reportedDate}}]</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:8px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="border:1px solid black;text-align:left">Customer</th>
              <th style="border:1px solid black;text-align:left">Invoice No.</th>
              <th style="border:1px solid black;text-align:left">Date</th>
              <th style="border:1px solid black;text-align:left">Sale Type</th>
              <th style="border:1px solid black;text-align:left">Net Amount</th>
              <th style="border:1px solid black;text-align:left">Credit Paid Amount</th>
              <th style="border:1px solid black;text-align:left">Remaining Amount</th>
            </tr>
          </thead>
          <tbody style="border:1px solid black;" v-for="(header, index) in customerCreditBalanceHeaderList" :key="index">
            <tr v-for="(item, i) in header.customerCreditBalanceList" :key="i">
              <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ header.customerName }}</td>
              <td style="border-left:1px solid black;text-align:left" v-else></td>
              <td style="border:1px solid black;text-align:left">{{ item.invoiceNo }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.createdDateInMilliSeconds | format-ms-date }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.saleType }}</td>
              <td style="border:1px solid black;text-align:right">{{ item.netAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right">{{ item.creditPaidAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right">{{ item.remainingAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td style="border:1px solid black;font-weight:bold" colspan="4">Sub Total</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{header.subTotalNetAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.subTotalCreditPaidAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.subTotalRemainingAmount | decFormat(6)}}</td>
            </tr>
          </tbody>
          <tr>
            <td style="border:1px solid black;font-weight:bold" colspan="4">Grand Total</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalNetAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalCreditPaidAmount | decFormat(6)}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalRemainingAmount | decFormat(6)}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--Print All-->
  </v-container>
</template>

<script>
import { customerCreditBalanceService } from "../../services/customer-credit-balance-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { saleTeamService } from "../../services/sale-team-service";

export default {
  name: "CategoryList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    printAllLoading: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Customer Credit Balance",
        disabled: true
      }
    ],
    clonequeryParams: new Object(),
    headers: [
      { text: "Status", value: "status", sortable: false },
      {
        text: "Created Date",
        align: "left",
        value: "createdDate",
        sortable: false
      },
      { text: "Due Date", value: "dueDate", sortable: false },
      { text: "Customer Code", value: "customerCode", sortable: false },
      { text: "Customer Name", value: "customerName", sortable: false },
      { text: "Invoice No.", value: "invoiceNo", sortable: false },
      { text: "Shop", value: "shop", sortable: false },
      { text: "Sale Team", sortable: false },
      { text: "Period Day", value: "periodDay", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
      {
        text: "Credit Paid Amount",
        value: "creditPaidAmount",
        sortable: false
      },
      { text: "Remaining Amount", value: "remainingAmount", sortable: false },
      { text: "Sale Type", value: "saleType", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },
    customerCreditBalanceList: [],
    allCustomerCreditBalanceList: [],
    customerCreditBalanceHeaderList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "FINISH", value: "FINISH" },
      { label: "CREDIT", value: "CREDIT" }
    ],
    dateTypeList: [
      { label: "Issue Date", value: "Issue Date" },
      { label: "Due Date", value: "Due Date" },
    ],
    reportedDate:  commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      status: "",
      saleType: "",
      customerNameCode: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      saleTeamIds: "",
      dateType: "Issue Date",
    },
    saleTypeList: [
      { label: "----All----", value: "" },
      { label: "RETAIL", value: "RETAIL" },
      { label: "WHOLE_SALE", value: "WHOLE_SALE" }
    ],
    totalNetAmount: 0,
    totalCreditPaidAmount: 0,
    totalRemainingAmount: 0,
    shopList: [],
    saleTeamList: [],
    todayDateInMilliSeconds: Date.parse(new Date().toISOString()),
  }),
  watch: {
    pagination: {
      handler() {
        this.findCustomerCreditBalance();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.saleType) {
      this.queryParams.saleType = this.$route.query.saleType;
    }
    if (this.$route.query.customerNameCode) {
      this.queryParams.customerNameCode = this.$route.query.customerNameCode;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.saleTeamIds) {
      this.queryParams.saleTeamIds = this.$route.query.saleTeamIds;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.onSearch();
    this.getAllShop();
    this.getActiveSaleTeams();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "CustomerCreditBalance",
        query: this.queryParams
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.findCustomerCreditBalance();
      this.findCustomerCreditBalanceSummary();
    },
    findCustomerCreditBalance() {
      this.showListLoading = true;
      customerCreditBalanceService
        .getCustomerCreditBalance(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then(res => {
          if (res.data) {
            this.customerCreditBalanceList = res.data.customerCreditBalanceList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    findCustomerCreditBalanceSummary() {
      customerCreditBalanceService
        .getCustomerCreditBalanceSummary(this.queryParams)
        .then(res => {
          if (res.data) {
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    printAll(divName) {
      this.printAllLoading = true;
      customerCreditBalanceService
        .getCustomerCreditBalanceSummary(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          customerCreditBalanceService
            .printCustomerCreditBalance(this.clonequeryParams, null, null)
            .then(res => {
              console.log(res.data);
              if (res.data) {
                this.customerCreditBalanceHeaderList =
                  res.data;
              }
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              var printContents = document.getElementById(divName).innerHTML;
              var reprintWindow = window.open(
                "",
                "MsgWindow",
                "width=500,height=500"
              );
              reprintWindow.document.write(printContents);
              setTimeout(() => {
                reprintWindow.print();
                reprintWindow.close();
              }, 600);
              this.printAllLoading = false;
            });
        });
    },
    exportAllCreditBalance() {
      this.printAllLoading = true;
      customerCreditBalanceService
        .exportCreditBalanceExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkColor(item) {
      let color = "black--text";
      if (
        item.remainingAmount > 0 &&
        item.dueDateInMilliSeconds <= this.todayDateInMilliSeconds
      ) {
        color = "red accent-2";
      }
      return color;
    },
  }
};
</script>